import React, { useState } from 'react';
import { Welcome } from './Welcome';
import { TimePreference } from './TimePreference';
import { EnergyLevel } from './EnergyLevel';
import { FocusArea } from './FocusArea';
import { Environment } from './Environment';
import { PersonalizeMore } from './PersonalizeMore';
import { AITransparency } from './AITransparency';
import { LoginScreen } from '../auth/LoginScreen';
interface OnboardingFlowProps {
  onComplete: (userData: any) => void;
  onLogin: () => void;
}
export const OnboardingFlow = ({
  onComplete,
  onLogin
}: OnboardingFlowProps) => {
  const [step, setStep] = useState(0);
  const [showLogin, setShowLogin] = useState(false);
  const [userData, setUserData] = useState({
    name: '',
    timePreference: '',
    energyLevel: '',
    focusArea: '',
    environment: [],
    goal: '',
    schedule: '',
    healthContext: ''
  });
  const [personalizeStep, setPersonalizeStep] = useState(0);
  // Update user data
  const updateUserData = (field: string, value: any) => {
    setUserData({
      ...userData,
      [field]: value
    });
  };
  // Handle next step
  const nextStep = () => {
    setStep(step + 1);
  };
  // Handle previous step
  const prevStep = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };
  // Handle personalize next step
  const personalizeNextStep = () => {
    if (personalizeStep < 2) {
      setPersonalizeStep(personalizeStep + 1);
    } else {
      // Move to AI transparency step
      nextStep();
    }
  };
  // Handle personalize previous step
  const personalizePrevStep = () => {
    if (personalizeStep > 0) {
      setPersonalizeStep(personalizeStep - 1);
    } else {
      // Go back to main flow
      prevStep();
    }
  };
  // Complete onboarding
  const handleComplete = () => {
    // Convert environment array to string for compatibility with existing code
    const formattedUserData = {
      ...userData,
      environment: userData.environment.join(',')
    };
    onComplete(formattedUserData);
  };
  // Show login screen
  const handleShowLogin = () => {
    setShowLogin(true);
  };
  // Go back from login to welcome
  const handleBackFromLogin = () => {
    setShowLogin(false);
  };
  // If showing login screen
  if (showLogin) {
    return <LoginScreen onLogin={onLogin} onBack={handleBackFromLogin} data-id="element-747" />;
  }
  // Render current step
  const renderStep = () => {
    switch (step) {
      case 0:
        return <Welcome name={userData.name} onNameChange={name => updateUserData('name', name)} onNext={nextStep} onLogin={handleShowLogin} data-id="element-748" />;
      case 1:
        return <TimePreference selected={userData.timePreference} onSelect={value => updateUserData('timePreference', value)} onNext={nextStep} onBack={prevStep} data-id="element-749" />;
      case 2:
        return <EnergyLevel selected={userData.energyLevel} onSelect={value => updateUserData('energyLevel', value)} onNext={nextStep} onBack={prevStep} data-id="element-750" />;
      case 3:
        return <FocusArea selected={userData.focusArea} onSelect={value => updateUserData('focusArea', value)} onNext={nextStep} onBack={prevStep} data-id="element-751" />;
      case 4:
        return <Environment selected={userData.environment} onSelect={value => updateUserData('environment', value)} onNext={nextStep} onBack={prevStep} data-id="element-752" />;
      case 5:
        return <PersonalizeMore userData={userData} updateUserData={updateUserData} onNext={personalizeNextStep} onBack={personalizePrevStep} currentStep={personalizeStep} data-id="element-753" />;
      case 6:
        return <AITransparency userData={userData} onComplete={handleComplete} onBack={prevStep} data-id="element-754" />;
      default:
        return null;
    }
  };
  return <div className="flex flex-col h-full" data-id="element-755">{renderStep()}</div>;
};